export default __webpack_public_path__ + "static/media/flag-myanmar.abf6fb86.svg";